"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const lodash_clonedeep_1 = tslib_1.__importDefault(require("lodash.clonedeep"));
const helpers_1 = require("../../tools/helpers");
const skipRoutes = [
    'login',
    'register',
    'verify',
    'not-found',
];
const globalActions = [];
function dispatchActions(to, from, store) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        console.group('dispatchActions');
        if (to.name && skipRoutes.includes(to.name)) {
            console.log('Skipped.');
            console.groupEnd();
            return true;
        }
        const loaderCount = to.matched.reduce((acc, cur) => (cur.beforeEnter === dispatchActions ? acc + 1 : acc), 0);
        if (loaderCount > 1) {
            const withLoader = to.matched.filter(m => m.beforeEnter === dispatchActions);
            console.warn(`It is recommended to have a dependency loader for only one matched route, but your have ${loaderCount}. Routes with loader: `, withLoader);
        }
        const metas = helpers_1.findRouteMetas(to);
        let actions = lodash_clonedeep_1.default(metas.actions || []);
        actions.push(...globalActions);
        actions = [...new Set(actions)];
        actions.sort((a, b) => globalActions.indexOf(b) - globalActions.indexOf(a));
        console.log('Queueing actions to dispatch:', actions);
        yield actions.reduce((result, action) => result.then(() => {
            let args = action;
            if (typeof args === 'function') {
                args = args(to, from, helpers_1.getStore());
            }
            if (!args) {
                return Promise.resolve(args);
            }
            if (!Array.isArray(args)) {
                args = [args];
            }
            console.log(`Dispatching ${args[0]}...`);
            return store.dispatch(...args);
        }), Promise.resolve(null));
        console.groupEnd();
        return true;
    });
}
exports.default = dispatchActions;
//# sourceMappingURL=dispatchActions.js.map